import {
  Package, Truck, ShoppingBag, Store, Layers, LayoutGrid, ReceiptText,
  FilePlus2, MoveVertical, ImageDown, Type, AlignLeft, ListChecks, Search, Sparkles, Wrench,
  FileSearch, ImagePlus, BookOpen, Calculator,
} from "lucide-react";

export const ICONS = {
  Package, Truck, ShoppingBag, Store, Layers, LayoutGrid, ReceiptText,
  FilePlus2, MoveVertical, ImageDown, Type, AlignLeft, ListChecks, Search, Sparkles, Wrench,
  FileSearch, ImagePlus, BookOpen, Calculator,
};

export function ToolIcon({ name, className }) {
  const Cmp = ICONS[name] || Wrench;
  return <Cmp className={className} />;
}
